/**
 * FlowMode - Journey-guided entity creation flow
 * Shows phase-driven entity cards with inline AI suggestions
 */

import { FlowLayout } from '@/components/flow/FlowLayout'

interface FlowModeProps {
  context: WorkspaceContext
}

interface WorkspaceContext {
  mode: string
  phaseId: string
  journeyMode: string
}

export function FlowMode({ context }: FlowModeProps) {
  return (
    <div className="h-full bg-warm-50">
      <FlowLayout />
    </div>
  )
}
